export default __webpack_public_path__ + "static/insfocus_medium_1-ebad09c867ef0bc5a4ca911c137df4e7.png";